import AuthControl from "./AuthControl";

export default AuthControl;